<template>
    <b-modal
        id="ModalUpdateArbo"
        title="Modifier une arborescence"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        hide-footer
    >
        <FormArbo
            :projectid="projectid"
            :applicationbuild="applicationbuild"
            :arbo="arbo"
            @saved="onSaved"
            class="mb-2"
        />
    </b-modal>
</template>
<script>
import FormArbo from "@/components/model/arbo/FormArbo";
export default {
    components: {
        FormArbo,
    },

    props: {
        arbo: { type: Object, required: true },
        projectid: { type: [String, Number], required: true },
        applicationbuild: { type: Object, required: false },
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalUpdateArbo");
            this.$emit("saved");
        },
    },
};
</script>
